import App from './App';
import * as Pinia from 'pinia';
import { createSSRApp } from 'vue';

import 'animate.css';
import cusEmpty from './components/cusEmpty';
import cusModal from './components/cusModal';
import cusPopup from './components/cuspop';
import cusButton from './components/cusButton';
import cusTabs from './components/cusTabs';
import cusToast from './components/cusToast';
import cusCollapse from './components/cusCollapse';
import cusDatePicker from './components/cusDatePicker';
import GlobalOffline from './components/GlobalOffline';
import LaunchLoading from './components/LaunchLoading.vue';
//#ifndef APP-PLUS
import './uni.webview.1.5.6.js';
//#endif

uni.$zp = {
    config: {
        'refresher-end-bounce-enabled': false
    }
};
export function createApp() {
    const app = createSSRApp(App);
    app.use(Pinia.createPinia());
    app.component('cusEmpty', cusEmpty);
    app.component('cusModal', cusModal);
    app.component('cusPopup', cusPopup);
    app.component('cusButton', cusButton);
    app.component('cusTabs', cusTabs);
    app.component('cusToast', cusToast);
    app.component('cusCollapse', cusCollapse);
    app.component('cusDatePicker', cusDatePicker);
    app.component('GlobalOffline', GlobalOffline);
    app.component('LaunchLoading', LaunchLoading);
    return {
        app,
        Pinia
    };
}
